import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IpsRoutingModule } from './ips-routing.module';
import { IpsComponent } from './ips.component';
import { SharedModule } from '@app/shared/shared.module';
import { IPS_SERVICE, IpsRequestsService } from './services/ips-requests.service';
import { AccessControlModule } from '@app/core/access-control/access-control.module';

@NgModule({
  declarations: [IpsComponent],
  imports: [CommonModule, IpsRoutingModule, SharedModule, AccessControlModule],
  providers: [
    {
      provide: IPS_SERVICE,
      useClass: IpsRequestsService,
    },
  ],
})
export class IpsModule {}
